import React from 'react';

const Loader = () => {
	return (
		<div className='loader__con'>
			<div className="honeycomb">
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
			</div>
		</div>
	);
};

export default Loader;
